import Link from 'next/link'
import { Dropdown } from 'react-bootstrap'
import { Designed } from 'web_core/types'
import { isBlank, unique } from 'web_core/utils'
import { getStrYearAndMonth, makeRankingDateList } from '~/utils/ranking'

type Props = {
  type: 'articles' | 'books'
  formSelectClassName?: string
  formSelectStyle?: React.CSSProperties
  selectedYear?: string
  selectedMonth?: string
  undefinedLabel?: string
}

export const RankingMonthSelector = ({
  type,
  selectedMonth,
  selectedYear,
  ...props
}: Designed<Props>) => {
  const monthAndYearList = makeRankingDateList().map((date) => {
    const [year, month] = getStrYearAndMonth(date).split('/')
    return { year, month }
  })

  const yearList = unique(monthAndYearList.map(({ year }) => year))
  const monthList = monthAndYearList
    .filter(({ year }) => year === selectedYear)
    .map(({ month }) => month)

  return (
    <div {...props}>
      <div className="d-flex gap-2">
        <Dropdown>
          <Dropdown.Toggle variant="link">
            {selectedYear !== undefined ? `${selectedYear}年` : '全期間'}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Link href={`/ranking/${type}`} passHref>
              <Dropdown.Item active={selectedYear === undefined}>
                全期間
              </Dropdown.Item>
            </Link>
            {yearList.map((year) => (
              <Link
                passHref
                key={year}
                href={`/ranking/${type}/${year}${
                  !isBlank(selectedMonth) && selectedMonth !== ''
                    ? `/${selectedMonth}`
                    : ''
                }`}
              >
                <Dropdown.Item active={selectedYear === year}>
                  {year}年
                </Dropdown.Item>
              </Link>
            ))}
          </Dropdown.Menu>
        </Dropdown>
        {selectedYear !== undefined && (
          <Dropdown>
            <Dropdown.Toggle variant="link">
              {selectedMonth !== undefined ? `${selectedMonth}月` : '全期間'}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Link passHref href={`/ranking/${type}/${selectedYear}`}>
                <Dropdown.Item active={selectedMonth === undefined}>
                  全期間
                </Dropdown.Item>
              </Link>
              {monthList.map((month) => (
                <Link
                  passHref
                  key={month}
                  href={`/ranking/${type}/${selectedYear}/${month}`}
                >
                  <Dropdown.Item active={selectedMonth === month}>
                    {month}月
                  </Dropdown.Item>
                </Link>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        )}
      </div>
    </div>
  )
}
